import { createAction } from "@reduxjs/toolkit";
import {
  REQUEST_SEARCH,
  RECEIVE_SEARCH,
  UPDATE_PERSONALISATION_PARAMS,
  SET_ADDITIONAL_QUERY_PARAMS,
  UPDATE_ADDITIONAL_QUERY_PARAMS,
  MORE_PRODUCTS_LOADED,
  PREVIOUS_PRODUCTS_LOADED,
  LOADING_MORE_PRODUCTS,
  LOADING_PREVIOUS_PRODUCTS,
  SET_NEW_SEARCH,
  CLEAR_NEW_SEARCH,
  DISMISS_FLOOR_FILTER,
  CLEAR_ON_VIEW_BEACON,
  CLEAR_ON_LOAD_BEACON,
  REFRESH_ADVERTISEMENT_BEACONS,
  ANCHOR_PRODUCT,
  UPDATE_IMAGE_GALLERY_DISMISS,
} from "../../constants";
import { filterInvalidProducts } from "../results/products";

export const toSerializableSearchError = (error) => ({
  code: error?.code || error?.name || "SEARCH_ERROR",
  message: error?.message || "Search request failed",
  origin: error?.origin || "search",
  requestId: error?.requestId || null,
});

const prepareSearchResponse = (response) => {
  if (response instanceof Error) {
    return { payload: toSerializableSearchError(response), error: true };
  }

  return {
    payload: {
      ...response,
      products: filterInvalidProducts(response.products),
    },
  };
};

export const requestProducts = createAction(REQUEST_SEARCH);
export const receiveProducts = createAction(
  RECEIVE_SEARCH,
  prepareSearchResponse,
);
export const moreProductsLoaded = createAction(
  MORE_PRODUCTS_LOADED,
  prepareSearchResponse,
);
export const previousProductsLoaded = createAction(
  PREVIOUS_PRODUCTS_LOADED,
  prepareSearchResponse,
);
export const loadingPreviousProducts = createAction(LOADING_PREVIOUS_PRODUCTS);
export const loadingMoreProducts = createAction(LOADING_MORE_PRODUCTS);

export const updatePersonalisationParams = createAction(
  UPDATE_PERSONALISATION_PARAMS,
);
export const setAdditionalQueryParams = createAction(
  SET_ADDITIONAL_QUERY_PARAMS,
);
export const updateAdditionalQueryParams = createAction(
  UPDATE_ADDITIONAL_QUERY_PARAMS,
);

export const dismissFloorFilter = createAction(DISMISS_FLOOR_FILTER);
export const setNewSearch = createAction(SET_NEW_SEARCH);
export const clearNewSearch = createAction(CLEAR_NEW_SEARCH);
export const refreshAdvertisementBeacons = createAction(
  REFRESH_ADVERTISEMENT_BEACONS,
);
export const clearOnViewBeacon = createAction(CLEAR_ON_VIEW_BEACON);
export const clearOnLoadBeacon = createAction(CLEAR_ON_LOAD_BEACON);

export const anchorProduct = createAction(ANCHOR_PRODUCT);
export const updateImageGalleryOnboardDismissed = createAction(
  UPDATE_IMAGE_GALLERY_DISMISS,
  (imageGalleryOnboardDismissed) => ({
    payload: { imageGalleryOnboardDismissed },
  }),
);
